import React from "react";
import images from "../../../Utils/importImages";

function LoginDetails({ loginDetail, setEditLoginDetail }) {
  console.log("loginDetail is : ", loginDetail);

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>Login Details</h3>
        <div className="editable-profile-action">
          {
            loginDetail.non_auth_prime_is_verified == false &&
          <div className="editable-profile-action">
            Edit{" "}
            <img
              src={images["edit-profile-details.svg"]}
              alt=""
              onClick={() => setEditLoginDetail(true)}
            />
          </div>
          }
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li>
          <label for="">Email</label>
          <div className="myprofile-general-value">
            {loginDetail.email == null ? (
              <span>Not Provided</span>
            ) : (
              loginDetail.email
            )}
            {loginDetail.auth_prime == "email" ? (
              loginDetail.auth_prime_is_verified == true ? (
                <span className="verifiednumber">
                  <img src={images["verified-icon.svg"]} alt="" /> Verified
                </span>
              ) : (
                ""
              )
            ) : loginDetail.non_auth_prime_is_verified == true ? (
              <span className="verifiednumber">
                <img src={images["verified-icon.svg"]} alt="" /> Verified
              </span>
            ) : (
              ""
            )}
          </div>
        </li>
        <li>
          <label for="">Mobile No.</label>
          <div className="myprofile-general-value">
          {loginDetail.phone == null ? (
              <span>Not Provided</span>
            ) : (
              loginDetail.phone
            )}
            {loginDetail.auth_prime == "phone" ? (
              loginDetail.auth_prime_is_verified == true ? (
                <span className="verifiednumber">
                  <img src={images["verified-icon.svg"]} alt="" /> Verified
                </span>
              ) : (
                ""
              )
            ) : loginDetail.non_auth_prime_is_verified == true ? (
              <span className="verifiednumber">
                <img src={images["verified-icon.svg"]} alt="" /> Verified
              </span>
            ) : (
              ""
            )}
          </div>
        </li>
      </ul>
    </div>
  );
}

export default LoginDetails;
